import { TextButton } from '@creditornot/cb-button';
import { CaretDown } from '@creditornot/cb-icons';
import { MenuItemGroup, MenuActionItem } from '@creditornot/cb-menu';
import { LegacyPopover } from '@creditornot/cb-popover';
import React from 'react';
import { CSSProperties, ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

type Props<T> = {
  className?: string;
  style?: CSSProperties;
  options: { value: T; label: string; icon?: ReactNode }[];
  variant?: 'black' | 'blue';
  value?: T;
  onChange?: (value: T) => void;
};

const Content = styled.div`
  min-width: 180px;
  max-width: 240px;
  max-height: 320px;
  overflow-y: auto;
  padding: 8px 16px;
`;

export const BorderlessSelect = <T extends string>({
  className,
  style,
  options,
  variant = 'black',
  value,
  onChange,
}: Props<T>) => {
  const intl = useIntl();
  const selectedOption = useMemo(() => options.find(option => option.value === value), [options, value]);
  return (
    <LegacyPopover
      className={className}
      style={style}
      placement="bottom-start"
      showOnHover={false}
      showOnClick
      closeOnClickInside
      renderArrow={false}
      disableContentPadding
      content={
        <Content>
          <MenuItemGroup>
            {options.map(option => (
              <MenuActionItem
                variant="black"
                key={option.value}
                onClick={() => onChange?.(option.value)}
                selected={option.value === value}
                icon={option.icon}
              >
                {intl.formatMessage({ id: option.label })}
              </MenuActionItem>
            ))}
          </MenuItemGroup>
        </Content>
      }
    >
      <TextButton variant={variant} icon={<CaretDown />} iconPosition="right">
        {intl.formatMessage({ id: selectedOption?.label })}
      </TextButton>
    </LegacyPopover>
  );
};
